import * as React from "react";
const options = { year: "numeric", month: "long", day: "numeric" };
const DateTime = ({ dateTime, ...rest }) => {
  const date = dateTime instanceof Date ? dateTime : new Date(dateTime);
  let { locale } = rest;
  if (locale) {
    locale = locale.replace("_", "-");
  }
  return /* @__PURE__ */ React.createElement("time", { dateTime: date.toISOString() }, date.toLocaleDateString(locale, options));
};
export {
  DateTime as default,
  options
};
//# sourceMappingURL=DateTime.js.map
